export const CANAL_VENTE_C = 'C';
export const CANAL_VENTE_W = 'W';
